import { IFeatures } from "app/data/types";
import { types } from "@vilocnv/allsetra-core";
import {
  MapSvg,
  GeozonesSvg,
  MembersSvg,
  GroupsSvg,
  AccountIcon,
  ObjectsIcon,
  Reports,
  keysInactiveIcon,
  AccountSettings,
  MileageDeviationsIcon,
  ActiveMileageDeviationsIcon
} from "assets/icons";
import {
  ActiveMapIcon,
  ActiveGeozoneIcon,
  ActiveObjectsIcon,
  ActiveUserIcon,
  ActiveGroupsIcon,
  ActiveAccountIcon,
  ActiveReportsIcon,
  ActiveKeysIcon,
  ActiveAccountSettingsIcon
  // ActiveMileageIcon
} from "components/ui/icons";
import {
  ADMIN_ROLES,
  RESTRICTED_ROLES
} from "app/data/helpers/rolePermissions";

export const getDrawerMenuItems = (
  t: any,
  userRoleName?: string,
  isDriver?: boolean,
  hasKeurmerkFeature?: boolean
): Array<types.IDrawerMenuItem> => {
  const baseMenuItems: Array<types.IDrawerMenuItem> = [
    {
      id: "map",
      name: t("drawerMenuLinks.map"),
      icon: MapSvg,
      path: "/dashboard",
      activeIcon: ActiveMapIcon
    },
    {
      id: "geozones",
      name: t("drawerMenuLinks.geozones"),
      icon: GeozonesSvg,
      path: "/dashboard/geozones",
      activeIcon: ActiveGeozoneIcon
    },
    {
      id: "objects",
      name: t("drawerMenuLinks.objects"),
      icon: ObjectsIcon,
      path: "/dashboard/objects",
      activeIcon: ActiveObjectsIcon
    },
    {
      id: "users",
      name: t("drawerMenuLinks.users"),
      icon: MembersSvg,
      path: "/dashboard/users",
      activeIcon: ActiveUserIcon
    },
    {
      id: "accounts",
      name: t("drawerMenuLinks.accounts"),
      icon: AccountIcon,
      path: "/dashboard/accounts",
      activeIcon: ActiveAccountIcon
    },
    {
      id: "groups",
      name: t("drawerMenuLinks.groups"),
      icon: GroupsSvg,
      path: "/dashboard/groups",
      activeIcon: ActiveGroupsIcon
    }
  ];

  const shouldShowMileageDeviations =
    userRoleName &&
    ADMIN_ROLES.includes(userRoleName) &&
    !isDriver &&
    hasKeurmerkFeature;

  if (shouldShowMileageDeviations) {
    baseMenuItems.push({
      id: "Mileage Deviations",
      name: t("drawerMenuLinks.mileageDeviations"),
      icon: MileageDeviationsIcon,
      path: "/dashboard/mileage-deviations",
      activeIcon: ActiveMileageDeviationsIcon
    });
  }

  return baseMenuItems;
};

export const getDrawerSubMenuLists = (
  t: any,
  features: IFeatures,
  accountId: string | null,
  isDriver?: boolean
): {
  [x: string]: Array<types.IDrawerMenuItem>;
} => {
  return {
    [t("drawerMenuLinks.admin")]: [
      {
        id: features.isRidesEnabled ? "mileage-report" : "tag-position-report",
        name: t("drawerMenuLinks.reports"),
        icon: Reports,
        path: "/dashboard/reports",
        activeIcon: ActiveReportsIcon
      },
      !isDriver && {
        id: "keys-manager",
        name: t("drawerMenuLinks.keysManager"),
        icon: keysInactiveIcon,
        path: "/dashboard/keys-manager",
        activeIcon: ActiveKeysIcon
      },
      !isDriver && {
        id: "driver-mileage",
        name: t("drawerMenuLinks.driverMileage"),
        icon: MileageDeviationsIcon,
        path: "/dashboard/driver-mileage",
        activeIcon: ActiveMileageDeviationsIcon
      },
      !isDriver && {
        id: "account-settings",
        name: t("drawerMenuLinks.accountSettings"),
        icon: AccountSettings,
        activeIcon: ActiveAccountSettingsIcon,
        path: "/dashboard/accounts/settings/" + accountId
      }
    ].filter(Boolean) as types.IDrawerMenuItem[]
  };
};

export const FIETSGESTOLEN_EXTERNAL_LINK = "https://www.enra.nl/tweede-slot/";

export const yesNoOptionsForDropdown = (translator: any) => [
  { label: translator ? translator("typography.yes") : "Yes", value: "yes" },
  { label: translator ? translator("typography.no") : "No", value: "no" }
];

export const paymentTermInDaysOptions = (translator: any) => [
  {
    days: 30,
    name: translator ? translator("paymentTerms.1month") : "1 month"
  },
  {
    days: 90,
    name: translator ? translator("paymentTerms.3month") : "3 months"
  },
  {
    days: 180,
    name: translator ? translator("paymentTerms.6month") : "6 months"
  }
];

export const DEFAULT_COORDINATES = { lat: 52.0, lng: 5.301137 };
